import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { ReactNode } from 'react';

interface ProtectedAdminRouteProps {
  children: ReactNode;
}

export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { isAdmin, isLoading } = useAuth();

  // If we're still loading the auth state, render nothing yet
  if (isLoading) {
    return null;
  }

  // If user is not admin, redirect to bills page
  if (!isAdmin) {
    return <Navigate to="/bills" replace />;
  }

  // Otherwise render the admin content
  return <>{children}</>;
}
